module.exports = __webpack_public_path__ + "img/navigate_connection_page.a60da71b.png";